import _styled from "@emotion/styled-base";
import { jsx } from '@emotion/core';
var SIZES = {
  small: '90px',
  medium: '130px',
  large: '210px'
};

var StarRatingImage = _styled("img", {
  target: "ezodat50",
  label: "StarRatingImage"
})("display:block;", function (props) {
  return {
    width: SIZES[props.size]
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU9zQiIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL2NvcmUnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xudmFyIFNJWkVTID0ge1xuICAgIHNtYWxsOiAnOTBweCcsXG4gICAgbWVkaXVtOiAnMTMwcHgnLFxuICAgIGxhcmdlOiAnMjEwcHgnLFxufTtcbnZhciBTdGFyUmF0aW5nSW1hZ2UgPSBzdHlsZWQuaW1nKHtcbiAgICBkaXNwbGF5OiAnYmxvY2snLFxufSwgZnVuY3Rpb24gKHByb3BzKSB7IHJldHVybiAoe1xuICAgIHdpZHRoOiBTSVpFU1twcm9wcy5zaXplXSxcbn0pOyB9KTtcbmV4cG9ydCB2YXIgU3RhclJhdGluZyA9IGZ1bmN0aW9uIChfYSkge1xuICAgIHZhciBfYiA9IF9hLnJhdGluZywgcmF0aW5nID0gX2IgPT09IHZvaWQgMCA/IDAgOiBfYiwgX2MgPSBfYS5zaXplLCBzaXplID0gX2MgPT09IHZvaWQgMCA/ICdtZWRpdW0nIDogX2M7XG4gICAgcmV0dXJuIChqc3goU3RhclJhdGluZ0ltYWdlLCB7IHNpemU6IHNpemUsIHNyYzogXCIvL2Nkbi50cnVzdHBpbG90Lm5ldC9icmFuZC1hc3NldHMvNC4xLjAvc3RhcnMvc3RhcnMtXCIgKyByYXRpbmcgKyBcIi5zdmdcIiB9KSk7XG59O1xuIl19 */");

export var StarRating = function StarRating(_a) {
  var _b = _a.rating,
      rating = _b === void 0 ? 0 : _b,
      _c = _a.size,
      size = _c === void 0 ? 'medium' : _c;
  return jsx(StarRatingImage, {
    size: size,
    src: "//cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-" + rating + ".svg"
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/StarRating/index.js
// module id = 1192
// module chunks = 0